export default {
	'userCancel': 'Hủy bỏ người dùng',
	'addrLp': 'Địa chỉ hợp đồng LP',
	'bscInLbb': 'Chuyển BSC sang LBBCoin',
	'goSwap': 'Giao dịch CSwap',
	'sumLbb': 'Tích lũy {0} OC',
	'lookLbb': 'Xem hợp đồng',
	'addrLbb': 'Địa chỉ hợp đồng OC',
	'addrDead': 'Địa chỉ hố đen',
	'addrMarket': 'Địa chỉ tiếp thị',
	'ratioTotal': 'Tổng điểm bán: 10%',
	'ratioLp': 'a. Hệ số thanh khoản: 5%',
	'ratioDead': 'b. Hệ số phá hủy: 3%',
	'ratioInv': 'c. Hệ số mời: 1%',
	'ratioMarket': 'D. Hệ số tiếp thị: 1%',
	'contractDesc': 'Thực hiện toàn bộ chuỗi logic',
	'contract': 'Hợp đồng',
	'inviteTotal': 'Phần thưởng mời toàn mạng: {0} OC',
	'inviteMy': 'Phần thưởng cho lời mời của tôi: {0} OC',
	'lpTotal': 'Phần thưởng thanh khoản toàn mạng: {0} OC',
	'lpMy': 'Phần thưởng thanh khoản của tôi: {0} OC',
	'lpDesc': 'Thanh khoản toàn lưới: {0}/{1} LCC',
	'lpAdd': 'Thêm thanh khoản',
	'lp': 'tính thanh khoản',
	'invSell': 'Tối đa 1% phần thưởng mời',
	'lpSell': 'Giữ thanh khoản trọng thưởng 5% mỗi lần bán',
	'myInvites': 'Thư mời của tôi',
	'effective': 'effective',
	'ineffective': 'ineffective',
	'myInviter': 'Giới thiệu của tôi',
	'invite': 'Thư mời',
	'inviteNotice1': 'Gửi cho nhau 0.1 OC',
	'inviteNotice2': 'Sau khi được xác nhận, lời mời đã thành công.',
	'inviteBind': 'Vui lòng liên kết tài liệu tham khảo của bạn',
	'chainConfirm': 'Trong chuỗi......',
	'{0} Operate Fast': 'Hoạt động quá thường xuyên, vui lòng tiếp tục sau vài giây',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': 'xác nhận',
	'Osnft Detail': 'Xem chi tiết',
	'{0} Not Enogugh': '{0} của bạn không đủ',
	'Operate Success': 'Thao tác thành công',
	'zlang143': 'Sao chép thành công',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'ocLockTitle': 'Khóa OC',
	'ocLockDeposit': 'Tiền gửi',
	'ocLockActive': 'Status',
	'ocLockReleased': 'Đã phát hành',
	'ocLockClaim': 'Rút',
	'themeNeon': 'Xanh neon',
	'themeIce': 'Mach bang',
	'themeViolet': 'Tim vang',
	'themeAurora': 'Bac ha cuc quang',
	'themeEmber': 'Dem lua',
	'themeMono': 'Don sac toi',
	'Refresh': 'Refresh',
	'No Records': 'No Records',
	'eventLogs': 'Event Logs',
	'eventCount': 'Records',
	'eventTotal': 'Amount Summary',
	'eventAll': 'All',
	'eventInviteFeature': 'Invite',
	'eventRewardFeature': 'Rewards',
	'eventBonusFeature': 'Mining',
	'eventLockFeature': 'Lock',
	'eventLock': 'Lock',
	'eventRelease': 'Release',
	'eventClaim': 'Claim',
	'eventBonus': 'Bonus',
	'eventInvite': 'Invite',
	'eventTransfer': 'Transfer',
	'eventOcLocked': 'OC Locked',
	'eventOcStaticRelease': 'Static Release',
	'eventOcDynamicRelease': 'Dynamic Release',
	'eventOcClaimed': 'Lock Claim',
	'eventBonusTriggered': 'Bonus Distributed',
	'eventBonusReceived': 'Bonus Received',
	'eventInviteRequested': 'Invite Requested',
	'eventDirectReward': 'Direct Reward',
	'eventLiquidityReward': 'Liquidity Reward',
	'eventSlowQueryProgress': 'Query is slow, checked block {0}/{1}',
	'eventTenLevelBonus': 'Ten-Level Mining',
	'eventTenLevelBonusReceived': 'Ten-Level Mining Received',
	'eventReferralConfirmed': 'Referral Confirmed',
	'eventEffectiveInvite': 'Effective Invite',
	'eventEffectiveLp': 'Effective Account',
	'eventTransferIn': 'Transfer In',
}
